<!-- 工作状况 -->

<template>
  <div class="applyInitiation_personal applyInitiation_work">
    <div class="applyInitiation_personal_head">
      <span>工作状况</span>
      <span class="red">(必填)</span>
    </div>
    <div class="applyInitiation_personal_main">
      <ul class="applyInitiation_personal_list clearfix">
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">职业</div>
          <el-input :disabled="isDisabled" v-model="workFormData.wk_profession" placeholder="请输入"></el-input>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">工作单位</div>
          <el-input :disabled="isDisabled" v-model="workFormData.wk_unit" placeholder="请输入"></el-input>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">单位性质</div>
          <el-select :disabled="isDisabled" v-model="workFormData.wk_company_type" placeholder="请选择">
            <el-option v-for="(item, index) in firmTypeList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <!-- <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">职业</div>
          <el-select v-model="workFormData.wk_profession" placeholder="请选择">
            <el-option v-for="(item, index) in occupationList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li> -->
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">工作性质</div>
          <el-select :disabled="isDisabled" v-model="workFormData.wk_nature" placeholder="请选择">
            <el-option v-for="(item, index) in workNatureList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">工作职务</div>
          <el-input :disabled="isDisabled" v-model="workFormData.wk_job" placeholder="请输入"></el-input>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">收入</div>
          <el-select :disabled="isDisabled" v-model="workFormData.wk_income" placeholder="请选择">
            <el-option v-for="(item, index) in incomeList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
      </ul>
      <div class="copy" v-if="!isDisabled" @click="handleSubmitWork">保存并继续</div>
    </div>
  </div>
</template>

<script>
import $DB from '../../../util/debounce'

export default {
  name: 'Worker',
  props: {
    // 用户信息
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 工作状况
      workerInfo: {
        wk_status: 0,
      },

      firmTypeList: [], // 单位性质（原公司类型）
      // occupationList: [], // 职业列表
      incomeList: [], // 收入列表
      workNatureList: [], // 工作性质列表

      workFormData: {
        wk_company_type: '', // 单位性质（原公司类型）
        wk_profession: '', // 职业
        wk_income: '', // 收入

        // 202406 新增
        wk_unit: '', // 工作单位
        wk_nature: '', // 工作性质
        wk_job: '', // 工作职务
      },
    }
  },
  computed: {
    isDisabled() {
      return this.userInfo.check_status === 2 || this.userInfo.check_status === 3
    },
  },
  created() {
    this.funLoadUserWorker()

    // 类型:1性别:2 民族;3身高;4体重:5属相;6星座:7血型;8信仰;9 籍贯;10长期居住地;11学历;12毕业院校【对应School表];13公司类型:14职业:15收入:16兄弟姐妹几人;17婚姻状况:18住房情况:19买车情况:20是否抽烟;21是否喝酒;22是否有孩子;23 有几个孩子:24 是否想要孩子;25 何时结婚;26年龄;27身高;28期待结婚时间;29所在地:30推荐指数;32 工作性质;33住房是否有贷款;34车辆是否有贷款;35父母亲情况;36父母亲工作情况;37父母亲是否有退休金;38是否原生家庭;39感情经历:40孩子情况:41抚养费;
    const obj = {
      13: 'firmTypeList', // 单位性质（原公司类型）
      // 14: 'occupationList', // 职业列表
      15: 'incomeList', // 收入列表
      32: 'workNatureList', // 工作性质列表
    }
    for (const key in obj) {
      this.funLodeCateList(+key, obj[key])
    }
  },
  methods: {
    // 获取工作状况
    funLoadUserWorker() {
      this.$axios.post('/api/member/getUserWorker').then((res) => {
        this.workerInfo.wk_status = res.data.data.wk_status
        if (res.data.code === 0) {
          this.workerInfo = res.data.data
          for (const key in this.workFormData) {
            this.workFormData[key] = this.workerInfo[key]
          }
        }
      })
    },

    /**
     * 获取下拉选择内容
     * @param {Number} type 类型
     * @param {String} propName data 中的字段名
     */
    funLodeCateList(type, propName) {
      this.$axios.post('/api/index/cateList', { type }).then((res) => {
        if (res.data.code === 0) {
          this[propName] = res.data.data[0].cate_name
        }
      })
    },

    // 保存并继续
    handleSubmitWork: $DB(function () {
      if (!this.workFormData.wk_profession.trim()) return this.$message.error('请输入职业')
      if (!this.workFormData.wk_unit.trim()) return this.$message.error('请输入工作单位')
      if (!this.workFormData.wk_company_type) return this.$message.error('请选择单位性质')
      if (!this.workFormData.wk_nature) return this.$message.error('请选择工作性质')
      if (!this.workFormData.wk_job.trim()) return this.$message.error('请输入工作职务')
      if (!this.workFormData.wk_income) return this.$message.error('请选择收入')

      // console.log({ ...this.workFormData })
      // return

      this.$axios.post('/api/member/userWorker', this.workFormData).then((res) => {
        if (res.data.code === 0) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }),
  },
}
</script>

<style lang="scss" src="../index.scss" scoped></style>
